<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="products.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="product"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <actions :product="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="products.per_page"
        layout="total, prev, pager, next"
        :total="products.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      products() {
        return this.$store.getters['product/products'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['product/tableConfig']));
      },
      loading() {
        return this.$store.getters['product/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('product/setCurrentPage', this.currentPage);
      this.$store.commit('product/setSorting', this.currentSort);
      await this.$store.dispatch('product/fetchAllWithPagination');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('product/setCurrentPage', val);
        this.$store.dispatch('product/fetchAllWithPagination');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('product/setSorting', { prop, order });
        this.$store.dispatch('product/fetchAllWithPagination');
      },
    },
  };
</script>

